export default __webpack_public_path__ + "static/media/vit-transparant.8f285299.png";